import { Image } from "@generalapplications/ui";

/** The mark alone, its light version in the dark scheme; BrandLink in the
 * header makes it the home link and names it. */
export function BrandMark() {
  return (
    <Image
      src="/brand/ga-mark-light.svg"
      darkSrc="/brand/ga-mark-dark.svg"
      width={50}
      height={30}
      eager
    />
  );
}
